import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router';
import { CounterBadge } from './CounterBadge';
import classNames from 'classnames';
import { useSettings } from 'src/modules/settings';
import { RoutesType, useRoute } from 'src/router/hooks/useRoute';

type HeaderNavigationItemType = 'LINK' | 'BUTTON';

export interface HeaderNavigationItemProps {
  type: HeaderNavigationItemType;
  path: RoutesType;
  title?: string;
  image?: JSX.Element;
  hasCounter: boolean;
  counterValue?: number;
}

export const HeaderNavigationItem: FC<HeaderNavigationItemProps> = ({
  type,
  path,
  title,
  image,
  hasCounter,
  counterValue
}) => {
  const { t } = useTranslation();
  const { isGameSearchActive } = useSettings();
  const { ROUTE } = useRoute();
  const { pathname } = useLocation();

  // This variable was added so that when the Live category is selected, the Games category is not highlighted
  const isLiveCategoryActive = pathname.includes(ROUTE.GAMES_LIVE.path) && path === 'GAMES';

  return (
    <NavLink
      to={ROUTE[path].get('', '')}
      className="cursor-pointer uppercase font-bold text-xl transition-all duration-200 px-1 py-2">
      {({ isActive }) => {
        const isHighlighted = isActive && !isGameSearchActive && !isLiveCategoryActive;
        return (
          <div className="flex justify-center items-center gap-2">
            {type === 'LINK' ? (
              <p
                className={classNames(
                  'text-h_link hover:text-h_hover border-b border-[transparent] hover:border-h_hover',
                  isHighlighted && '!text-h_hover border-b border-h_hover'
                )}>
                {t(title ?? '')}
              </p>
            ) : (
              <>{image}</>
            )}
            {hasCounter && <CounterBadge value={counterValue} />}
          </div>
        );
      }}
    </NavLink>
  );
};
